import * as DataProviders from '../../types/data-providers';
import React from 'react';
import { useData, dataFromDataset } from './DataProviderCache';
import * as AlarmManager from '../domain/alarm-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { PromiseType } from '../../types/general';

type ContextState = DataProviders.Data<PromiseType<ReturnType<typeof AlarmManager.getAlarmDetails>>>;

const Context = React.createContext<ContextState | null>(null);

function useTimelineEventDetailData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useTimelineEventDetailData must be used within a TimelineEventDetailDataProvider');
    }
    return contextState;
}

const TimelineEventDetailDataProvider: React.FC<{ alarmId: string; deviceId: string }> = (props) => {
    const authHelper = useAuthHelper();

    const { dataset } = useData({
        cacheKey: 'timeline-event-detail-data',
        id: props.alarmId,
        dataFn: React.useCallback(
            () =>
                AlarmManager.getAlarmDetails(
                    authHelper,
                    { alarmId: props.alarmId, deviceId: props.deviceId }
                ),
            [authHelper, props.alarmId, props.deviceId]
        ),
    });

    return <Context.Provider value={dataFromDataset(dataset)}>{props.children}</Context.Provider>;
};

const TestTimelineEventDetailDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { TimelineEventDetailDataProvider, TestTimelineEventDetailDataProvider, useTimelineEventDetailData };
